<template>
  <div class="row">
    <label class="col-12 form-control-label">Преимущества для клиента</label>
    <small class="col-12 text-muted">Например: «Безналичный расчет»</small>
    <hr>
    <div class="col-12">
      <div class="input-group">
        <input
          class="form-control"
          type="text"
          v-model="newAdvantage"
          @keyup.enter="addAdvantage"
          autocomplete="off">
        <span
          class="input-group-addon"
          id="basic-addon1"
          @click="addAdvantage">
          <i class="fa fa-plus"/>
        </span>
      </div>
      <div class="col-12">
        <span
          v-if="error"
          class="small help-block text-danger">{{error}}</span>
      </div>
      <div class="mt-1">
        <div class="row">
          <div
            class="col-6"
            v-for="item in advantages"
            :key="item.id">
            <div class="advantage_item alert alert-info">
              {{ item.name }}
              <div
                class="float-right text-info"
                @click="removeAdvantage(item.id)">&times;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TcInputAdvantages',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      newAdvantage: '',
      // TODO просто пример, потом подставить "this.value"
      advantages: [
        {
          id: 0,
          name: 'Комната ожидания'
        },
        {
          id: 1,
          name: 'Wi-fi'
        },
        {
          id: 2,
          name: 'Безналичный расчет'
        }
      ],
      error: ''
    }
  },
  methods: {
    addAdvantage () {
      this.error = ''
      if (this.newAdvantage.length < 2) {
        this.error = 'Введите преимущество'
        return false
      }
      this.advantages.push({
        id: this.getNewId(),
        name: this.newAdvantage
      })
      this.newAdvantage = ''
    },
    removeAdvantage (id) {
      this.advantages = this.advantages.filter((el) => {
        return el.id !== id
      })
    },
    getNewId () {
      if (this.advantages.length > 0) {
        return this.advantages[this.advantages.length - 1].id + 1
      } else {
        return 1
      }
    }
  },
  created () {
    // TODO потом задать значение в data()
    this.advantages = this.value
  }
}
</script>

<style scoped lang="scss">
hr {
  width: 100%;
  margin-right: 15px;
  margin-left: 15px;
  margin-top: 4px;
}
span.input-group-addon {
  cursor: pointer;
  background: #1b6aaa;
  color: white;

  &:hover {
    background: #143b63;
   }
}
.advantage_item {
  border-bottom: 1px solid #1e95e2;

  .text-info {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// TcInputAdvantages.vue?1495cd31